


angular.module('forms.fields.password_single', [])
.directive('passwordSingleField', function($translate){
return {
	require: ['ngModel'],
	restrict: 'A',
	scope: true,
	link: function($scope, element, attrs, controllers) {
		var ngModel = controllers[0];

		$scope.pass = {pass:''};
		$scope.$watchCollection('pass', function(pass) {
			if (!pass) return;
			var value = pass.pass;
			
			ngModel.$setViewValue(value);
		}, true);
		
		ngModel.$render = function() {
			$scope.pass.pass = ngModel.$modelValue;
			$scope.pass.repeat = ngModel.$modelValue;
    	};
	},
}

});